import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Keeps addresses without a trailing "/": a link written with one
 * (/ayurveda-packages/) opens the page at /ayurveda-packages, the address the
 * rest of the site and the canonical tags use. A page opened or refreshed
 * directly is cleaned earlier, by the script in index.html.
 */
const NoTrailingSlash = () => {
  const { pathname, search, hash, state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname.length > 1 && pathname.endsWith("/")) {
      navigate((pathname.replace(/\/+$/, "") || "/") + search + hash, { replace: true, state });
    }
  }, [pathname, search, hash, state, navigate]);

  return null;
};

export default NoTrailingSlash;
